/**
 * The browser tab's title (spec 128 R2), behind a function so a component's
 * effect can set and restore it without writing to a global from inside the
 * component, which the React Compiler's rules refuse.
 */
export function readDocumentTitle(): string {
  return document.title;
}

export function writeDocumentTitle(title: string): void {
  document.title = title;
}
